const setMemberDashboardValues = payload => ({
  type: "SET_MEMBER_DASHBOARD_VALUES",
  payload
});

const setNonMemberDashboardValues = payload => ({
  type: "SET_NON_MEMBER_DASHBOARD_VALUES",
  payload
});

const setActiveDashboard = payload => ({
  type: "SET_ACTIVE_DASHBOARD",
  payload
});

export default {
  setMemberDashboardValues,
  setNonMemberDashboardValues,
  setActiveDashboard
};
